/** A bulk mutation wired with the standard success/error toasts. */
import { useToast } from '@vnetwork/ui/feedback';
import { useWafBulk, wafExtractError, type WafBulkOp } from '@/api/waf';

export function useBulkApply<Op extends WafBulkOp>(serviceId: string, op: Op) {
  const { show } = useToast();
  return useWafBulk(serviceId, op, {
    onSuccess: (r) =>
      show({ tone: 'success', title: `Applied to ${r.applied} domain${r.applied === 1 ? '' : 's'}` }),
    onError: (e) => show({ tone: 'danger', title: wafExtractError(e, 'Apply failed') }),
  });
}
